import React, {useEffect, useState} from 'react'
import {convertirNumeroConComas} from '../../../../utils/numbers.utils'
import TableDTE from '../../../../components/Tables/TableDTE/TableDTE'

const TablaFacturacionCF = (props: any) => {
  const [rows, setRows] = useState([])

  useEffect(() => {
    const productos = props.rows.map((p: any, i: number) => ({
      ...p, 
      unidadMedida: p.unidadMedida, 
      index: i, 
      tipoNew: p.tipo === "p" ? "Producto" : "Servicio", 
      cantidadNew: p.cantidad, 
      precioNew: `$${convertirNumeroConComas(p.precio)}`, 
      cantidadDescuentoNew: `$${convertirNumeroConComas(p.cantidadDescuento)}`, 
      ventasGravadas: props?.checkExentoImpuesto ? "$0.00" : `$${convertirNumeroConComas(p.total)}`, 
      ventasExentas: props?.checkExentoImpuesto ? `$${convertirNumeroConComas(p.total)}` : "$0.00", 
      ventasSujetas: "$0.00", 
    }))
    setRows(productos)
  }, [props?.rows, props?.checkExentoImpuesto])

  return (
    <><TableDTE rows={rows} openModalEliminar={props.openModalEliminar} openModalEditar={props.openModalEditar} sinAcciones={props?.sinAcciones} idDoc={props?.idDoc}/>
      <div className="cf-calculos-producto" style={{width: '100%'}}>
        <table>
          <tbody>
            <TableRowResponsiveCard text={`Suma de operaciones de ventas ${props?.checkExentoImpuesto === true ? "exentas" : "gravadas"}`} valor={props?.datos?.total} className="cf-subtotal"/>
            <TableRowResponsiveCard text={"Impuesto al Valor Agregado 13%"}  valor={"0.00"} className="cf-subtotal" />
            <TableRowResponsiveCard text={"Subtotal"}  valor={props?.datos?.total} className="cf-subtotal" />
            <TableRowResponsiveCard text={"Otros impuestos"}  valor={props?.datos?.otrosImpuestos} className="cf-subtotal" />
            <TableRowResponsiveCard text={"IVA percibido 1%"}  valor={props?.datos?.totalIvaPercibido} className="cf-subtotal" />
            <TableRowResponsiveCard text={"IVA retenido 1%"}  valor={props?.datos?.totalImpuesto2} className="cf-subtotal" />
            <TableRowResponsiveCard  text={"Retención renta 10%"}  valor={props?.datos?.totalRetencionRenta} className="cf-descuento" />
            <TableRowResponsiveCard text={"Monto total a la operación"}  valor={props?.datos?.totalMontoOperacion} className="cf-total" />
            <TableRowResponsiveCard text={"Total"}  valor={props?.datos?.totalPagar} className="cf-total" />
          </tbody>
        </table>
      </div></>
  )
}

const TableRowResponsiveCard = (props: any) => {
  return (
    <tr className={props?.className}>
      <td>{props.text}</td>
      <td>${convertirNumeroConComas(props?.valor) ?? '0.00'}</td>
    </tr>
  )
}

export default TablaFacturacionCF
